/* PureState mobile sticky bar v2 (floating glass pill): show/hide (sentinel or scroll offset, overlays, footer,
   viewport), runtime form wiring to the hero <product-form>, price + bundle-line echo from the hero root / the checked
   bundle option, label states mirrored from the hero submit button, one-line button fit check (.is-small → ellipsis),
   --ps-sticky-bar-height / --ps-sticky-bar-clearance on :root for the body padding while visible.
   No copy in JS: every label, unit and duration is pre-rendered as a data-* attribute by sections/ps-sticky-bar.liquid. */
(function () {
  if (customElements.get('ps-sticky-bar')) return;
  var doc = document, root = doc.documentElement;
  var dm = !!(window.Shopify && Shopify.designMode);
  var reduced = function () { return !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches); };
  var pubsub = function () { return typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined'; };
  var heroRoot = function () { return doc.querySelector('product-info[data-ps-product-form]'); };
  var heroForm = function () {
    var r = heroRoot(), id = r && r.dataset.psProductForm, f = id && doc.getElementById(id);
    if (f && f.tagName === 'FORM') return f;
    return doc.querySelector('product-info form[data-type="add-to-cart-form"]');
  };
  var checkedOption = function () {
    var input = doc.querySelector('product-info .ps-bundle__input:checked');
    return input && input.closest ? input.closest('.ps-bundle__option') : null;
  };
  var addMq = function (mq, fn) { if (!mq) return; if (mq.addEventListener) mq.addEventListener('change', fn); else if (mq.addListener) mq.addListener(fn); };
  var removeMq = function (mq, fn) { if (!mq) return; if (mq.removeEventListener) mq.removeEventListener('change', fn); else if (mq.removeListener) mq.removeListener(fn); };

  customElements.define('ps-sticky-bar', class extends HTMLElement {
    connectedCallback() {
      this.d = this.dataset;
      this.button = this.querySelector('[data-ps-sticky-button]');
      this.labelEl = this.querySelector('[data-ps-sticky-label]');
      this.spinner = this.querySelector('.ps-sticky-bar__spinner');
      this.priceEl = this.querySelector('[data-ps-sticky-price]');
      this.bundleEl = this.querySelector('[data-ps-sticky-bundle]');
      if (!this.button) return;
      this.state = { triggered: false, overlay: false, footer: false, allowed: true, noForm: false, forced: false };
      this.shown = false;
      this.offs = [];
      var self = this;
      this.h = {
        load: function () { self.rewire(); },
        bundle: function () { self.syncPrice(); self.wire(); self.watchHero(); },
        select: function (ev) { if (ev.target && ev.target.contains(self)) { self.state.forced = true; self.update(); } },
        deselect: function (ev) { if (ev.target && ev.target.contains(self)) { self.state.forced = false; self.update(); } },
        scroll: function () { self.onScroll(); },
        measure: function () { self.measure(); self.fit(); },
        resize: function () {
          clearTimeout(self.resizeT);
          self.resizeT = setTimeout(function () { if ((parseInt(self.d.triggerOffset, 10) || 0) > 0 && self.io) self.watchTrigger(); }, 200);
        },
        media: function () { self.checkViewport(); },
        state: function () { self.syncState(); }
      };
      root.style.setProperty('--ps-sticky-bar-clearance', (parseInt(this.d.clearance, 10) || 0) + 'px');
      this.wire();
      this.watchHero();
      this.syncPrice();
      this.watchTrigger();
      this.watchOverlays();
      this.watchFooter();
      this.watchViewport();
      this.watchSize();
      doc.addEventListener('shopify:section:load', this.h.load);
      doc.addEventListener('ps:bundle-change', this.h.bundle);
      if (dm) {
        doc.addEventListener('shopify:section:select', this.h.select);
        doc.addEventListener('shopify:section:deselect', this.h.deselect);
      }
      if (pubsub()) {
        this.offs.push(subscribe(PUB_SUB_EVENTS.cartUpdate, function (data) {
          if (data && data.source && data.source !== 'product-form') return;
          setTimeout(self.h.state, 0);
        }));
      }
      this.update();
    }

    disconnectedCallback() {
      if (!this.h) return; /* connectedCallback bailed before wiring (no [data-ps-sticky-button]) */
      doc.removeEventListener('shopify:section:load', this.h.load);
      doc.removeEventListener('ps:bundle-change', this.h.bundle);
      doc.removeEventListener('shopify:section:select', this.h.select);
      doc.removeEventListener('shopify:section:deselect', this.h.deselect);
      window.removeEventListener('scroll', this.h.scroll);
      window.removeEventListener('resize', this.h.measure);
      window.removeEventListener('resize', this.h.resize);
      clearTimeout(this.resizeT);
      removeMq(this.mqT, this.h.media);
      removeMq(this.mqD, this.h.media);
      ['io', 'footObs', 'heroObs', 'bodyObs', 'dialogObs', 'ro'].forEach(function (k) { if (this[k]) { this[k].disconnect(); this[k] = null; } }, this);
      this.offs.forEach(function (off) { if (typeof off === 'function') off(); });
      this.offs = [];
      clearTimeout(this.hideT);
      doc.body.classList.remove('ps-sticky-bar--visible');
      root.style.setProperty('--ps-sticky-bar-height', '0px');
    }

    /* ---- form wiring ---- */
    wire() {
      var action = this.d.ctaAction || 'add_to_cart';
      var needsForm = action === 'add_to_cart' || action === 'add_and_checkout';
      var form = heroForm();
      if (!needsForm) { this.state.noForm = false; return; }
      if (form) {
        /* form.id is shadowed by Dawn's <input name="id"> inside the form → read the attribute, never the property */
        var formId = form.getAttribute('id');
        if (!formId) { formId = 'PsProductForm-' + (this.d.section || 'hero'); form.setAttribute('id', formId); }
        this.button.setAttribute('form', formId);
        this.button.setAttribute('type', 'submit');
        this.button.setAttribute('data-ps-cta-action', action);
        this.state.noForm = false;
        return;
      }
      if (this.d.fallback === 'hide') { this.state.noForm = true; return; }
      this.button.removeAttribute('form');
      this.button.setAttribute('type', 'button');
      this.button.setAttribute('data-ps-cta-action', 'scroll_to_buybox');
      this.state.noForm = false;
    }

    rewire() {
      this.wire();
      this.watchHero();
      this.syncPrice();
      this.watchTrigger();
      this.watchFooter();
      this.update();
    }

    /* ---- hero button state (loading / disabled) ---- */
    watchHero() {
      var form = heroForm(), b = form && form.querySelector('[type="submit"]');
      if (this.heroObs && this.heroBtn === b) return;
      if (this.heroObs) { this.heroObs.disconnect(); this.heroObs = null; }
      this.heroBtn = b || null;
      if (b && 'MutationObserver' in window) {
        this.heroObs = new MutationObserver(this.h.state);
        this.heroObs.observe(b, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'class'] });
      }
      this.syncState();
    }

    syncState() {
      var b = this.heroBtn, btn = this.button;
      var disabled = !!(b && b.hasAttribute('disabled'));
      var loading = !disabled && !!(b && b.classList.contains('loading'));
      var text = this.d.label || '';
      if (disabled) text = this.d.labelSoldOut || (window.variantStrings && window.variantStrings.soldOut) || text;
      else if (loading) text = this.d.labelAdding || text;
      var changed = false;
      if (this.labelEl && this.labelEl.textContent !== text) { this.labelEl.textContent = text; changed = true; }
      if (btn.disabled !== disabled) btn.disabled = disabled;
      btn.setAttribute('aria-busy', loading ? 'true' : 'false');
      btn.classList.toggle('is-loading', loading);
      if (this.spinner && this.spinner.hidden === loading) { this.spinner.hidden = !loading; changed = true; }
      if (changed) this.fit();
    }

    /* ---- one-line button: base font size, .is-small when the label would overflow, then CSS ellipsis ---- */
    fit() {
      var btn = this.button, lbl = this.labelEl;
      if (!lbl || this.hidden) return;
      btn.classList.remove('is-small');
      if (lbl.scrollWidth > lbl.clientWidth + 1) btn.classList.add('is-small');
    }

    /* ---- price + bundle line echo ---- */
    bundleText(qty) {
      var n = parseInt(qty, 10);
      if (!n || n < 1) return '';
      var unit = n === 1 ? (this.d.bundleUnitOne || '') : (this.d.bundleUnitOther || '');
      var text = unit ? n + ' ' + unit : String(n);
      /* duration: the checked hero option's data-ps-duration when the hero exposes it, else this section's per-quantity
         setting (getAttribute: dataset would camel-case data-bundle-duration-1 to "bundleDuration-1") */
      var opt = checkedOption();
      var duration = (opt && opt.dataset.psDuration) || this.getAttribute('data-bundle-duration-' + n) || '';
      var sep = (this.d.bundleSeparator || '').trim();
      if (duration) text += (sep ? ' ' + sep + ' ' : ' ') + duration;
      return text;
    }

    syncPrice() {
      var r = heroRoot();
      if (!r) return;
      var price = r.dataset.psSelectedPrice || '', qty = r.dataset.psSelectedQty || '';
      if (this.priceEl && price && this.priceEl.textContent !== price) this.priceEl.textContent = price;
      if (this.bundleEl && qty) {
        var txt = this.bundleText(qty);
        if (this.bundleEl.textContent !== txt) this.bundleEl.textContent = txt;
        this.bundleEl.hidden = !txt;
      }
      this.fit();
    }

    /* ---- trigger ---- */
    watchTrigger() {
      var self = this;
      if (this.io) { this.io.disconnect(); this.io = null; }
      window.removeEventListener('scroll', this.h.scroll);
      var mode = this.d.triggerMode || 'buybox_cta_out_of_view';
      var target = null;
      if (mode === 'buybox_cta_out_of_view') {
        target = doc.querySelector('product-info [data-ps-cta-sentinel]') || doc.getElementById('buy-box');
      }
      if (target && 'IntersectionObserver' in window) {
        /* Root = the area ABOVE the viewport top (moved up by trigger_offset_px), so "intersecting" means "scrolled above".
           A state change then always fires a callback, even when the target jumps past the whole viewport in one frame
           (anchor links); a viewport-rooted observer would see "outside → outside" and stay silent.
           Zero-area sentinel: the spec reports intersectionRatio 1 while intersecting; a tall fallback (#buy-box) needs
           ratio 1 = fully above. Re-created on resize because the offset is a percentage of the viewport height. */
        var offset = parseInt(this.d.triggerOffset, 10) || 0;
        var vh = Math.max(1, window.innerHeight || root.clientHeight || 1);
        var bottom = -(100 + (offset * 100) / vh);
        this.io = new IntersectionObserver(function (entries) {
          var en = entries[entries.length - 1];
          var on = en.isIntersecting && en.intersectionRatio >= 0.999;
          if (on !== self.state.triggered) { self.state.triggered = on; self.update(); }
        }, { rootMargin: '100000px 0px ' + bottom.toFixed(3) + '% 0px', threshold: [0, 1] });
        this.io.observe(target);
        return;
      }
      window.addEventListener('scroll', this.h.scroll, { passive: true });
      this.onScroll();
    }

    onScroll() {
      var y = window.scrollY || root.scrollTop || 0;
      var on = y > (parseInt(this.d.scrollOffset, 10) || 600);
      if (on !== this.state.triggered) { this.state.triggered = on; this.update(); }
    }

    /* ---- overlays: cart drawer / Dawn modals (body.overflow-hidden*) and any open <dialog> ---- */
    watchOverlays() {
      var self = this;
      var check = function () {
        var open = false;
        if (self.d.hideCartOpen === 'true') open = /(^|\s)overflow-hidden/.test(doc.body.className || '');
        if (!open && doc.querySelector('dialog[open]')) open = true;
        if (open !== self.state.overlay) { self.state.overlay = open; self.update(); }
      };
      this.checkOverlay = check;
      if ('MutationObserver' in window) {
        this.bodyObs = new MutationObserver(check);
        this.bodyObs.observe(doc.body, { attributes: true, attributeFilter: ['class'] });
        this.dialogObs = new MutationObserver(function (records) {
          for (var i = 0; i < records.length; i++) {
            if (records[i].target && records[i].target.tagName === 'DIALOG') { check(); return; }
          }
        });
        this.dialogObs.observe(doc.body, { attributes: true, attributeFilter: ['open'], subtree: true });
      }
      check();
    }

    /* ---- footer proximity ---- */
    watchFooter() {
      var self = this;
      if (this.footObs) { this.footObs.disconnect(); this.footObs = null; }
      this.state.footer = false;
      if (this.d.hideNearFooter !== 'true' || !('IntersectionObserver' in window)) return;
      var footer = doc.querySelector('.shopify-section-group-footer-group');
      if (!footer) return;
      this.footObs = new IntersectionObserver(function (entries) {
        var en = entries[entries.length - 1];
        if (en.isIntersecting !== self.state.footer) { self.state.footer = en.isIntersecting; self.update(); }
      }, { threshold: 0 });
      this.footObs.observe(footer);
    }

    /* ---- viewport gating (mobile always; tablet / desktop per setting) ---- */
    watchViewport() {
      if (!window.matchMedia) return;
      this.mqT = matchMedia('(min-width: 750px)');
      this.mqD = matchMedia('(min-width: 990px)');
      addMq(this.mqT, this.h.media);
      addMq(this.mqD, this.h.media);
      this.checkViewport();
    }

    checkViewport() {
      var ok = true;
      if (this.mqD && this.mqD.matches) ok = this.d.showDesktop === 'true';
      else if (this.mqT && this.mqT.matches) ok = this.d.showTablet === 'true';
      if (ok !== this.state.allowed) { this.state.allowed = ok; this.update(); }
    }

    /* ---- height → --ps-sticky-bar-height (pill height + its bottom offset: inset + safe area; the transform does not
            count, so the slide-in animation never skews it) + --ps-sticky-bar-clearance (clearance_px); ps-base.css adds
            both to body.ps-sticky-bar--visible padding-bottom ---- */
    watchSize() {
      if ('ResizeObserver' in window) {
        this.ro = new ResizeObserver(this.h.measure);
        this.ro.observe(this);
      }
      window.addEventListener('resize', this.h.measure, { passive: true });
      window.addEventListener('resize', this.h.resize, { passive: true });
    }

    measure() {
      if (this.hidden) return;
      var h = this.getBoundingClientRect().height;
      var offset = parseFloat(getComputedStyle(this).bottom) || 0;
      if (h > 0) root.style.setProperty('--ps-sticky-bar-height', Math.round(h + offset) + 'px');
    }

    /* ---- visibility ---- */
    update() {
      var s = this.state;
      var show = s.allowed && !s.noForm && (s.forced || (s.triggered && !s.overlay && !s.footer));
      if (show) this.show(); else this.hide();
    }

    show() {
      clearTimeout(this.hideT);
      if (this.shown) return;
      this.shown = true;
      this.hidden = false;
      this.measure();
      this.fit();
      doc.body.classList.add('ps-sticky-bar--visible');
      var self = this;
      if (reduced()) { this.classList.add('is-visible'); return; }
      requestAnimationFrame(function () { requestAnimationFrame(function () { if (self.shown) self.classList.add('is-visible'); }); });
    }

    hide() {
      if (!this.shown) return;
      this.shown = false;
      this.classList.remove('is-visible');
      doc.body.classList.remove('ps-sticky-bar--visible');
      var self = this;
      clearTimeout(this.hideT);
      this.hideT = setTimeout(function () { if (!self.shown) self.hidden = true; }, reduced() ? 0 : 220);
    }
  });
})();
